module.exports = __webpack_public_path__ + "media/images/favicon/favicon-4a2987a9f024bbf4dbadf00f04cdd707.ico";